import { render, staticRenderFns } from "./v10Menu.vue?vue&type=template&id=1e8138e8&"
import script from "./v10Menu.vue?vue&type=script&lang=js&"
export * from "./v10Menu.vue?vue&type=script&lang=js&"
import style0 from "./v10Menu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports